module.exports = __webpack_public_path__ + "img/kachel_aloevia_ORALCARE.8410f7d3.png";